export default "/images/logo.svg?80fd420aaea2588c6ea5930cdec4345c";